export default __webpack_public_path__ + "static/media/gatsby.08d0682b.svg";